import React from 'react';
import { appConfig } from '../../lib/config';
import { cn } from '../../lib/utils';
import AppIcon from './AppIcon';

interface AppLogoProps {
  showDescription?: boolean;
  className?: string;
}

/**
 * マーク + ワードマーク（LogMe）の横並びロックアップ。
 *
 * 色はこのラッパーの currentColor で決まり、マーク・文字ともそれを継承する。
 * 既定は #16224E 固定。認証画面のようにナイトモードでも白いカードの上に置く場合は
 * そのままでよい。ヘッダーのようにテーマ追従の面へ置く場合だけ
 * `className="text-[#16224E] dark:text-white"` のように呼び出し側で指定する。
 */
export const AppLogo: React.FC<AppLogoProps> = ({
  showDescription = true,
  className,
}) => {
  return (
    <div className={cn('flex items-center gap-3 text-[#16224E]', className)}>
      <AppIcon size={12} className="text-current" />
      <div className="flex flex-col">
        <span className="text-lg font-bold tracking-[-0.02em]">
          {appConfig.wordmark}
        </span>
        {showDescription && (
          <span className="text-sm opacity-60">
            {appConfig.description}
          </span>
        )}
      </div>
    </div>
  );
};

export default AppLogo;
